import { BaremetricsCalendar } from 'src/app/reusables/baremetrics-calendar/baremetrics-calendar.component';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { CvCustomDialogService } from 'src/app/reusables/custom-dialog/cv-custom-dialog.service';
import { CvCxAssignToolDTO, CvCxAssignToolOptions, CvCxEntities } from 'src/app/reusables/assign-tool/cv-cxone-assign-tool/cv-cxone-assign-tool.models';
import { CvCxoneAssignToolComponent } from 'src/app/reusables/assign-tool/cv-cxone-assign-tool/cv-cxone-assign-tool.component';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { CvMultiSelectSelectionChangedArgs } from 'src/app/reusables/multi-select/multi-select.models';
import { DatePipe } from '@angular/common';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { first } from 'rxjs/operators';
import { GamesService } from '../../../services/games.service';
import { ManualAwardsService } from '../../../services/manual-awards.service';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ProfileDTO } from 'src/app/admin/user/user-admin.model';
import { Subject } from 'rxjs';
import { UserAdminService } from 'src/app/admin/user/user-admin.service';
import { ValidationHelperService } from 'src/app/reusables/services/validation-helper.service';

import moment, { MomentInput } from 'moment';

interface ViewChange {
  view: any;
  item: any;
  old: any;
  isCancelled: any
}

interface ModalDetails {
  title: string;
  msg: string;
  confirmButton?: string;
  cancelButton?: string
}
@Component({
  selector: 'cv-awards-add-edit',
  templateUrl: './awards-add-edit.component.html',
  styleUrl: './awards-add-edit.component.scss',
  providers: [DialogService]
})
export class AwardsAddEditComponent implements OnInit, OnChanges {
  @Input() item: {} | any;
  @Input() folders: [] | any;
  @Input() badgeIDs: [] | any;
  @Input() coinValue: number | any;
  @Input() manualAwards: any[] = [];
  @Input() view: number;
  @Input() resetToOriginal: () => void;
  @Output() onChangeView = new EventEmitter<ViewChange>();
  @Input() _old: any;
  @Input() isCopy: boolean;
  @Output() onSaveNewFolder = new EventEmitter<string>();
  isLoadingManualAward = false;

  public isSaving: boolean = false;
  status: number[] = [];
  rolesList: any;
  logins: [] = [];
  profilesSelected: any[] = [];
  private _oldSubject = new Subject<{}>();
  private assignModal: DynamicDialogRef;

  msgLocalization = new Map();

  modalOptions: NgbModalOptions = {
    keyboard: false,
    backdrop: 'static',
    centered: true,
  };
  public localizationDic: Map<string, string> = new Map();

  //For group list
  columns = [];
  newDataArray = [];
  groupsExpanded: any;
  fileName = '';
  showAssingTool = false;
  customBadgeCreatorVisible = false;
  public listProfileDTOs: ProfileDTO[] = [];
  public localizationMessages: Map<string, string>;
  gf: any
  startDate: Date;
  endDate: Date;
  earliestDate: moment.Moment = moment().subtract(1, 'days');;
  earliestDateforTo: moment.Moment = moment().subtract(1, 'days');
  latestDate: Date;
  ongoingState: boolean = false;
  //dialog
  okLabel: string;
  cancelLabel: string;
  coins: string;
  isCxOne: boolean;

  constructor(
    public localizationService: CVLocalizationService,
    private manualAwardsService: ManualAwardsService,
    private dialogService: CvCustomDialogService,
    private validationHelper: ValidationHelperService,
    private gamesService: GamesService,
    private datePipe: DatePipe,
    private service: UserAdminService,
    public cvConfigurationService: CvConfigurationService,
    public dialogSrvc: DialogService,
  ) { }

  async ngOnInit() {
    this.isCxOne = this.cvConfigurationService.isCxOne;
    this._oldSubject.subscribe(value => {
      this._old = value;
    });
    this.isCopy = true;
    this.initAsync();
    await this.loadRolesData();
    this.updateProfilesSelected();
    this.manualAwardsService.loadManualAwards();
    this.manualAwardsService.loadingManualAward.subscribe(isLoading => {
      this.isLoadingManualAward = isLoading;
    });
  }

  async loadRolesData() {
    await this.manualAwardsService.getAllProfileDTOs().then((response: any) => {
      this.rolesList = response.map(profile => {
        return {
          value: profile.ProfileID,
          name: profile.ProfileName
        };
      });
    });

    if (this.item.AssignedRoles && this.item.AssignedRoles.length > 0) {
      this.item.AssignedRoles.forEach(role => {
        this.status.push(role.RoleID);
      });
    }

    await this.manualAwardsService.getAllLoginsByCompany().then((response: any) => {
      this.logins = response;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes._old) {
      this._oldSubject.next(changes._old.currentValue);
    }
    if (changes.item) {
      this.updateProfilesSelected();
    }
  }

  updateProfilesSelected(): void {
    if (this.item && this.item.AssignedRoles && this.item.AssignedRoles.length > 0) {
      this.item.AssignedRoles = this.item.AssignedRoles.filter(role => role.RoleID !== -1);
      this.getNumberOfUsers();
    } else {
      this.profilesSelected = [];
    }
  }

  async initAsync() {
    this.setData();
    this.gf = this.gamesService.data;
    this.localizationDic = await this.localizationService.GetSection("Manual_Awards");
    this.localizationMessages = await this.localizationService.GetSection("Games");
    this.okLabel = this.localizationService.getCachedText("Common", "Ok", "Ok");
    this.cancelLabel = this.localizationService.getCachedText("Common", "Cancel_Button", "Cancel");

    await this.localizationService.GetSection("Manual_Awards_Validation").then((map) => {
      this.msgLocalization = map;
    });
  }

  setData() {
    this.groupsExpanded = false;
    this.newDataArray = [];
    this.columns = this.item.AssignedGroups;

    this.item.awardLimitValue = this.item.AwardLimitValue ?? 0;
    this.item.awardLimitPeriod = this.getAwardPeriod(this.item.AwardLimitPeriod);
    this.item.isUnlimited = this.item.IsUnlimited ?? false;

    this.columns.sort(function compare(a, b) {
      if (a.GroupName < b.GroupName)
        return -1;

      if (a.GroupName > b.GroupName)
        return 1;

      return 0;
    });
    this.newDataArray = this.columnize(this.columns.slice(0, 21));

    //set award duration
    this.startDate = this.item.StartDate ? new Date(this.item.StartDate) : new Date();
    this.setEndAwardDuration()
    this.coins = this.formatWithThousandSeparator(Number(this.item.Coins));
  }

  setEndAwardDuration() {
    if (!this.validateDate(this.item.EndDate)) {
      this.ongoingState = true;
      this.item.EndDate = null;
    } else {
      if (this.item.EndDate !== null) {
        const endDate = new Date(this.item.EndDate);
        this.item.EndDate = endDate;
      }
    }
  }

  columnize(arr) {
    var totRows = Math.ceil(arr.length / 3);
    var newArr = [];
    for (var i = 0; i < arr.length; i += totRows) {
      newArr.push(arr.slice(i, i + totRows));
    }
    return newArr;
  }

  openCustomBadgeDialog() {
    this.customBadgeCreatorVisible = true;
  };

  getCoinValue() {
    return this.coinValue;
  };

  assignButtonClick() {
    this.showAssingTool = true;
  };

  datePlaceHolder(): string {
    return this.gamesService.getLocalizedMessage('Select_Date', 'Select Date');
  }

  removeContentEditable(event) {
    const elementWithContentEditable = event.target.firstChild?.firstChild?.firstChild;
    if (elementWithContentEditable && elementWithContentEditable.setAttribute) {
      elementWithContentEditable.setAttribute('contenteditable', false);
    }
  }

  getLocalizationString(key: string, defaultValue: string) {
    if (this.localizationDic) {
      if (this.localizationDic.has(key)) {
        return this.localizationDic.get(key);
      }
    }
    return defaultValue;
  }

  onAssignmentsChanged(eventData?: any[]) {
    const obj = {
      empAssignAll: false,//true if the user selects something in the modal otherwise false
      emp: [],
      rec: [],
      attr: [],
      coreAssignAtType: null,
      coreAssignAtLevel: 0
    };
    if (eventData && eventData.length) {
      for (let listItem of eventData) {
        if (listItem.BaseGroupType == 0)
          obj.emp.push(listItem);
        else if (listItem.BaseGroupType == 1)
          obj.rec.push(listItem);
        else if (listItem.AttributeValueID != null)
          obj.attr.push(listItem);
      }
      if (obj.attr.length > 0) {
        obj.attr = [...new Map(obj.attr.map(item => [item['AttributeValueName'], item])).values()]
      }
      this.item.AssignedGroups = obj.emp;
      this.setData();
    } else if (eventData == null || eventData.length <= 0) {
      obj.empAssignAll = false;
    } else {
      obj.empAssignAll = true;
    }
  }

  existsAward = (awardName: string): boolean => {
    if (this.manualAwardsService.data?.manualAwards.length === 0) return false;
    const award = this.manualAwardsService.data.manualAwards.find(award => award.Name?.toLowerCase() === awardName.toLowerCase());
    return !!award;
  };

  validate(): boolean {
    let msg = (key, failsafe) => {
      let columnNameLocalization = this.msgLocalization.get(key);
      if (columnNameLocalization && columnNameLocalization.length > 0)
        return columnNameLocalization;
      else
        return failsafe;
    };

    this.validationHelper.validationInstance();
    if (this.existsAward(this.item.Name) &&
      (this.item.RuleID == 0 || this.item.Name !== this._old.Name)) {
      this.validationHelper.addValidationError(msg("Award_Name_Duplicated", "The name of this award has already been taken."), true);
    }

    this.validationHelper.test(this.item.Name, { Required: msg("Name_Required", "Name is required.") });
    this.validationHelper.test(this.item.Folder, { Required: msg("Folder_Required", "Folder is required.") });
    this.validationHelper.test(this.item.BadgeID, { Required: msg("Badge_Required", "Please select a badge.") });

    if (!this.cvConfigurationService.isCxOne) {
      this.validationHelper.test(this.item.AssignedRoles, { Required: msg("Role_Required", "Please select one or more roles.") });
    }

    if (!this.item.isUnlimited) {
      this.validationHelper.test(this.item.awardLimitValue, {
        Required: msg("AwardLimit_Required", "Award limit value is required."),
        DigitOnly: msg("Coin_Invalid", "Coin value must be a valid number"),
        MinValue: { Minimum: 1, Message: msg("AwardLimit_TooLow", "Award limit value must be at least 1.") },
        MaxValue: { Maximum: 99, Message: msg("AwardLimit_TooHigh", "Award limit value must not exceed 99.") },
        WholeNumberOnly: msg("AwardLimit_WholeNumber", "Award limit value must be a whole number.")
      });

      this.validationHelper.test(this.item.awardLimitPeriod, {
        Required: msg("AwardLimitPeriod_Required", "Please select an award limit period.")
      });
    }

    if (this.item.Folder.toLowerCase().trim() == "(all)")
      this.validationHelper.addValidationError(msg("Folder_Cannot_Be_All", "Folder cannot be \"(all)\""), true);

    if (this.item.Coins === undefined) {
      //Edge doesn't enforce numbers in a numeric text box...the value just comes back as undefined
      this.validationHelper.addValidationError(msg("Coin_Invalid", "Coin value must be a valid number."), true);
    }

    if (this.item.Coins != 0) {
      this.validationHelper.test(this.item.Coins, {
        MinValue: { Minimum: 0, Message: msg("Coin_Negative", "Coin value must not be a negative number.") },
        DigitOnly: msg("Coin_Invalid", "Coin value must be a valid number"),
        WholeNumberOnly: msg("Coin_Whole_Only", "Coin value must be a valid whole number")
      });
    }

    this.validateEndDate();

    if (this.validationHelper.status !== "error") {
      return true;
    }
    else {
      const messages = this.validationHelper.messages;
      let errorMessage = "<ul>";
      messages.forEach(message => {
        errorMessage += `<li>${message.replace(/\n/g, '<br>')}</li>`;
      });
      errorMessage += "</ul>";

      const modalTitle = this.localizationService.getCachedText("Manual_Awards_Validation", "Award_Validation_Error_Title", "Award Validation Error");

      if (this.cvConfigurationService.isCxOne) {
        this.modalOptions.windowClass = "cxone-modal-awards-container";
        this.dialogService.showDialog(modalTitle, `<div class="modal-body-validation"> ${errorMessage} </div>`,
          13, '', this.okLabel, true, null, null, '', true, this.modalOptions);
      } else {
        this.dialogService.showDialog(modalTitle, errorMessage, 4, '', this.okLabel, true, null, null, 'modal-alert', true, this.modalOptions);
      }
    }
    return false;
  };

  validateAwardLimitInput(event: any) {
    const input = event.target;
    let value = input.value.replace(/[^0-9]/g, '');

    if (value === '') {
      input.value = '';
      this.item.awardLimitValue = null;
    } else {
      let numValue = parseInt(value, 10);
      if (numValue > 99) {
        numValue = 99;
      }
      input.value = numValue.toString();
      this.item.awardLimitValue = numValue;
    }
  }

  onlyNumberKey(event: KeyboardEvent) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  validateEndDate() {
    if (!this.ongoingState) {
      this.validationHelper.test(this.item.EndDate, {
        Required: this.msgLocalization.get("EndDate_Required") || "An end date is required if this award is not going to run indefinitely (ongoing)."
      });
    }
  }

  //Replacing special characters for its respective ascii code
  xssFilter(txt) {
    return txt
      .replace(/\//g, '&#47;')
      .replace(/&/g, '&#38;')
      .replace(/"/g, '&#34;')
      .replace(/'/g, '&#39;')
      .replace(/`/g, '&#96;')
      .replace(/</g, '&#60;')
      .replace(/>/g, '&#62;')
      .replace(/\$/g, '&#36;')
      .replace(/{/g, '&#123;')
      .replace(/}/g, '&#125;')
      .replace(/\\/g, '&#92;');
  }

  emitViewChange(view: any, item: any, old: any, isCancelled: boolean) {
    const viewChange: ViewChange = { view, item, old, isCancelled };
    this.onChangeView.emit(viewChange);
  }

  saveManualAward() {
    this.defaultAwardValues();
    if (this.validate()) {
      this.isSaving = true;
      this.item.AssignedEmpGroups = this.item.AssignedGroups;
      if (this.item.AssignedEmpGroups != null && this.item.AssignedEmpGroups.length > 0) {
        this.item.GroupLevel = this.item.AssignedEmpGroups[0].GroupLevel;
      }

      if (this.item.StartDate === null) {
        this.item.StartDate = this.startDate;
      }

      // ! Duplicated the item to avoid changing the original item connected to the ngModel
      let copyOfItem = Object.assign({}, this.item);
      copyOfItem.Name = this.xssFilter(copyOfItem.Name);
      const awardLimitPeriodValue = this.getAwardLimitPeriodValue(copyOfItem.awardLimitPeriod);
      const itemToSend = { ...copyOfItem, awardLimitPeriod: awardLimitPeriodValue };

      this.manualAwardsService.saveManualAward(itemToSend)
        .then((resolved: any) => {
          if (this.item.RuleID == 0) {
            //insert       
            if (!this.folders.includes(this.item.Folder)) {
              this.manualAwards.push({ Key: this.item.Folder, Value: [] });
              this.folders.push(this.item.Folder);
              this.onSaveNewFolder.emit(this.item.Folder);
            }
            const match = this.manualAwards.find(f => f.Key == this.item.Folder);
            if (match) {
              if (match.Value.length === 0) {
                match.Value = [];
              }
              match.Value.push(resolved);
            }
            //returning item to its original value 
            this.item = this._old;

            const matchOld = this.manualAwards.find(f => f.Key === this._old.Folder);
            if (matchOld) {
              matchOld.Value.push(this._old);
              matchOld.Value = matchOld.Value.filter(value => value.Folder === matchOld.Key);
            }
          } else { //Modify
            for (let k = 0; k < this.manualAwards.length; k++) {
              for (let i = 0; i < this.manualAwards[k].Value.length; i++) {
                if (this.manualAwards[k].Value[i].RuleID == resolved.RuleID) {
                  this.manualAwards[k].Value[i] = resolved;
                }
              }
            }
          }

          this.emitViewChange(0, resolved, this._old, false);
        })
        .catch((error) => {
          console.error(error);
        }).finally(() => {
          this.isSaving = false;
        });
    }
  };


  getGroupName() {
    if (this.item.AssignedGroups.length > 0) {
      const gtmatch = this.gf.GroupTypes.filter((gt) => { return gt.BaseGroupType == 0 && gt.GroupLevel == this.item.AssignedGroups[0].GroupLevel });
      if (gtmatch != null && gtmatch.length > 0)
        return gtmatch[0].GroupTypeName;
    }
  }

  async cancelAddEditFlow() {
    const cancelModalDetails = await this.getCancelModalLocalization();
    if (this.cvConfigurationService.isCxOne) {
      this.modalOptions.windowClass = "cxone-modal-awards-container";
      this.dialogService.showDialog(cancelModalDetails['cxone'].title, `<div class="modal-body-text"> ${cancelModalDetails['cxone'].msg} </div>`,
        11, cancelModalDetails['cxone'].confirmButton, cancelModalDetails['cxone'].cancelButton, true, () => { this.emitViewChange(0, this.item, this._old, true); },
        () => { }, '', true, this.modalOptions);
    } else {
      this.dialogService.showDialog(cancelModalDetails['pm'].title, cancelModalDetails['pm'].msg, 4, this.cancelLabel, this.okLabel, true, () => {
        this.emitViewChange(0, this.item, this._old, true);
      }, () => { }, 'modal-alert', true, this.modalOptions);
    }
  };

  deleteAssignGroups() {
    this.item.AssignedGroups = [];
    this.setData();
  }

  deleteSelection() {
    if (this.cvConfigurationService.isCxOne) {
      this.modalOptions.windowClass = "cxone-modal-awards-container";
    }
    
    this.dialogService.showDialog(
      this.localizationMessages.get("Confirm_Remove"),
      this.localizationMessages.get("Confirm_Remove_Message"),
      this.cvConfigurationService.isCxOne ? 11 :  4,
      this.cancelLabel,
      this.okLabel,
      true,
      () => { this.deleteAssignGroups(); },
      () => { },
      this.cvConfigurationService.isCxOne ? '' : 'modal-alert',
      true,
      this.modalOptions);
  }

  expandList() {
    if (!this.groupsExpanded) {
      this.newDataArray = this.columnize(this.columns);
    } else {
      this.newDataArray = this.columnize(this.columns.slice(0, 21));
    }
    this.groupsExpanded = !this.groupsExpanded;
  }

  customBadgeSaved(imageID) {
    this.badgeIDs.push(imageID);
    if (this.item != null)
      this.item.BadgeID = imageID;

    this.customBadgeCreatorVisible = false;

    const maBadgeContainer = document.querySelector('.maBadgeContainer');
    if (maBadgeContainer) {
      maBadgeContainer.scrollTop = maBadgeContainer.scrollHeight;
    }
  };

  // Award limit functions
  resetLimitValues() {
    if (this.item.isUnlimited) {
      this.item.awardLimitValue = 0;
      this.item.awardLimitPeriod = '';
    }
  }

  onCheckboxChange(): void {
    if (this.ongoingState) {
      this.resetEndDate();
    }
    this.validateEndDate();
  }

  resetEndDate(): void {
    this.item.EndDate = null;
    this.endDate = null;
    this.latestDate = null;
  }

  handleStartDateChanged(startDate: BaremetricsCalendar) {
    this.startDate = startDate.current_date ? startDate.current_date.toDate() : null;
    let dateFormat = this.datePipe.transform(this.startDate, CVAngularDateTimeFormat)
    this.item.StartDate = dateFormat;

    // Update earliestDateforTo to be the day after the selected start date
    this.earliestDateforTo = moment(this.startDate).add(1, 'days');

    // If the current endDate is now invalid, reset it
    if (this.endDate && moment(this.endDate).isBefore(this.earliestDateforTo)) {
      this.resetEndDate();
    }
  }

  handleEndDateChanged(endDate: BaremetricsCalendar) {
    const selectedEndDate = endDate.current_date ? endDate.current_date.toDate() : null;

    this.endDate = selectedEndDate;
    this.latestDate = this.endDate;
    //set time
    if (this.endDate !== null) {
      this.endDate.setHours(23);
      this.endDate.setMinutes(59);
      this.endDate.setSeconds(0);
      let dateFormat = this.datePipe.transform(this.endDate, CVAngularDateTimeFormat)
      this.item.EndDate = dateFormat;
    } else {
      this.item.EndDate = null;
    }
    this.validateEndDate();
  };

  validateDate(date) {
    const endDate = new Date(date);
    const year = endDate.getUTCFullYear();
    const actualYear = new Date().getUTCFullYear();

    return year > 1 && year <= actualYear;
  }

  onMultiSelectValueChanged(event: CvMultiSelectSelectionChangedArgs) {
    this.item.AssignedRoles = [];
    event.value.forEach(roleId => {
      let ruleRole = {
        RoleID: roleId
      };
      this.item.AssignedRoles.push(ruleRole);
    });

    this.item.allRolesSelected = event.wasSelectAll;

    this.getNumberOfUsers();
  }

  getNumberOfUsers() {
    const assignedRoleIDs = this.item.AssignedRoles.map(role => role.RoleID);

    if (this.logins.length > 0) {
      let newProfilesSelected = [...this.profilesSelected];

      this.item.AssignedRoles.forEach((role) => {
        const roleId = role.RoleID;
        const exist = newProfilesSelected.some(profile => profile.id === roleId);

        if (!exist) {
          let userLogins = this.logins.filter((user: any) => {
            return user.ProfileID === roleId && user.Active;
          });

          const roleName = this.rolesList.find(role => role.value === roleId)?.name;

          newProfilesSelected.push({
            id: roleId,
            numberOfUsers: userLogins.length,
            name: roleName
          });
        }
      });

      this.profilesSelected = newProfilesSelected
        .filter(profile => assignedRoleIDs.includes(profile.id))
        .filter(profile => profile.name !== undefined && profile.name !== null)
        .sort((a, b) => a.name.localeCompare(b.name));
    }
  }

  formatProfilesSelected(name: string, numberOfUsers: any): string {
    return `${name} (${numberOfUsers})`;
  }

  getAwardLimitPeriodValue(period: string | number): number {
    switch (period) {
      case 'week':
        return 1;
      case 'month':
        return 2;
      case 'quarter':
        return 5;
      case 'allTime':
        return 6;
      default:
        return 0;
    }
  }

  getAwardPeriod(period) {
    switch (period) {
      case 1:
        return "week";
      case 2:
        return "month";
      case 5:
        return "quarter";
      case 6:
        return "allTime";
      default:
        return "";
    }
  }

	async getCancelModalLocalization(): Promise<Record<string, ModalDetails>> {
		return {
			pm: {
				title: await this.localizationService.GetLocalText("Manual_Awards_Validation", "Confirm_Action", "Confirm Action"),
				msg: await this.localizationService.GetLocalText("Manual_Awards_Validation", "Confirm_Cancel_Message", "Are you sure you want to cancel? All unsaved progress will be lost.")
			},
			cxone: {
				title: await this.localizationService.GetLocalText("Manual_Awards_Validation", "Cancel_Confirmation_Header", "Leave?"),
				msg: await this.localizationService.GetLocalText("Manual_Awards_Validation", "Cancel_Modal_Lost_Message", "All changes will be lost."),
				confirmButton: await this.localizationService.GetLocalText("Manual_Awards_Validation", "Cancel_Modal_Confirm_Btn", "Stay"),
				cancelButton: await this.localizationService.GetLocalText("Manual_Awards_Validation", "Cancel_Modal_Cancel_Btn", "Leave"),
			}
		}
	}

	defaultAwardValues() {
		if (this.cvConfigurationService.isCxOne) {
			//default isUnlimited
			this.item.isUnlimited = true;
			this.item.awardLimitValue = 0;
			this.item.awardLimitPeriod = '';

			//default ongoingState
			this.ongoingState = true;
			this.item.EndDate = null;
			this.startDate = new Date();
			this.item.StartDate = moment(this.item.StartDate || this.startDate).format(CVMomentDateFormat)

			//default roles
			this.item.AssignedRoles = [];

			//default xp
			this.item.XP = 0;
		}
	}
	
    openAssignModal() {
        if (this.assignModal != null)
            return;

        let assigned: CvCxEntities = {
            emp: [],
            rec: [],
            agentAttribute: [],
            login: []
        };

        assigned["emp"] = this.item?.AssignedGroups;

        let options: CvCxAssignToolOptions = {
            modalTitle: this.getLocalizationString("Assign_Employee_Group", "Assign Employee Group"),
            modalSaveLabel: this.getLocalizationString("Assign", "Assign"),
            modalCancelLabel: this.getLocalizationString("Cancel", "Cancel"),
            useBulkAdd: false,
            singleAdd: false,
            singleLevel: true,
            singleType: true,
            showTypeValues: { emp: true, rec: false, agent_att: false, logins: false },
            assignedEntities: assigned,
            maxEmpLevel: 2,
            singleAssignValidation: true, //this is used to show the validation message
            singleAssignMessage: this.getLocalizationString("Assign_Single_Group_Message_Award", "An award can be assigned to either an agent or a team, but not both.")
        };

        this.assignModal = this.dialogSrvc.open(CvCxoneAssignToolComponent, {
            width: "1198px",
            height: "720px",
            baseZIndex: 10000,
            data: {
                options: options
            },
            styleClass: 'cx-one-ui awards-assignment-modal btn-bg-is-white'
        });

        this.assignModal.onClose.pipe(first()).subscribe(this.assignToolClosed.bind(this));
    }
    
    assignToolClosed(dto: CvCxAssignToolDTO): void {
        if (dto != null) {
            this.item?.AssignedGroups?.splice(0);
            this.item.AssignedGroups = [...dto.selected["emp"], ...dto.assigned["emp"]];
            this.setData();
        }
        this.assignModal = null;
    }

	formatNumber(event: Event) {
		const inputElement = event.target as HTMLInputElement;
		let coinValue = inputElement.value.replace(/\D/g, '');

		if (coinValue.length > 9) {
			coinValue = coinValue.substring(0, 9);
		}

		const numericValue = Math.abs(Math.trunc(Number(coinValue)));
		this.coins = this.formatWithThousandSeparator(numericValue);
		inputElement.value = this.coins;
		//keep only numbers
		this.item.Coins = numericValue;
	}

	formatWithThousandSeparator(value: number): string {
		return value.toLocaleString(typeof CVCultureName !== 'undefined' ? CVCultureName : 'en-US');
	}
}
